export default __webpack_public_path__ + "static/media/SWT1890.34I-40860_-24166_0.a0fe6c8b.jpg";